module.exports = __webpack_public_path__ + "img/secCtrlCenter_forceReset.0ce03ba2.png";